var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-movie-container as-flex main-center cross-center" },
    [
      _c(
        "div",
        { staticClass: "main-poster as-flex main-center cross-center" },
        [
          _vm.mainMovieInfo.poster_url
            ? _c("img", {
                staticClass: "poster-img",
                attrs: { src: _vm.mainMovieInfo.poster_url, alt: "主影片海报" },
              })
            : _c("img", {
                staticClass: "poster-img",
                attrs: {
                  src: require("../../assets/images/movie-poster.png"),
                  alt: "主影片海报",
                },
              }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "main-info as-flex flex-vertical main-start cross-center",
        },
        [
          _c(
            "div",
            { staticClass: "top-maininfo as-flex main-between cross-end" },
            [
              _c(
                "div",
                { staticClass: "left-title f-3 as-flex main-start cross-end" },
                [
                  _c("span", { staticClass: "movie-title as-nowrap" }, [
                    _vm._v(_vm._s(_vm.mainMovieInfo.title || "--")),
                  ]),
                  _vm._v(" "),
                  _c("clickSlider", {
                    staticClass: "movie-tags as-nowrap",
                    attrs: { movieTags: _vm.mainMovieInfo.tags },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "right-time f-1 fc-gray-2 as-nowrap" }, [
                _vm._v(_vm._s(_vm.mainMovieInfo.launch + "上映")),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bottom-detail as-flex main-start cross-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "left-hot-index as-flex flex-vertical main-start cross-start",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "as-flex flex-vertical main-start cross-start f-2",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-title as-flex main-start cross-end f-2",
                        },
                        [
                          _c("span", [_vm._v("热度指标")]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "热度指标包括认知度、兴趣度、首选度，适用于映前的市场分析",
                                placement: "top",
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "question-tip-icon icon-2",
                                attrs: {
                                  tabindex: "0",
                                  src: require("../../assets/images/question@3x.png"),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "f-1 fc-gray-2" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.offsetMapping[_vm.mainMovieInfo.offset]
                                ) +
                                ")"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-line as-full-width as-flex main-start cross-end f-1 fc-gray-2",
                        },
                        [
                          _c("span", { staticClass: "tag-title" }, [
                            _vm._v("认知"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tag-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mainMovieInfo.awareness &&
                                  _vm.mainMovieInfo.awareness.value
                                  ? _vm.mainMovieInfo.awareness.value + "%"
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "(均值" +
                                _vm._s(
                                  _vm.mainMovieInfo.awareness
                                    ? _vm.mainMovieInfo.awareness.average + "%"
                                    : "--"
                                ) +
                                ")"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-line as-full-width as-flex main-start cross-end f-1 fc-gray-2",
                        },
                        [
                          _c("span", { staticClass: "tag-title" }, [
                            _vm._v("兴趣"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tag-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mainMovieInfo.interest &&
                                  _vm.mainMovieInfo.interest.value
                                  ? _vm.mainMovieInfo.interest.value + "%"
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "(均值" +
                                _vm._s(
                                  _vm.mainMovieInfo.interest
                                    ? _vm.mainMovieInfo.interest.average + "%"
                                    : "--"
                                ) +
                                ")"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-line as-full-width as-flex main-start cross-end f-1 fc-gray-2",
                        },
                        [
                          _c("span", { staticClass: "tag-title" }, [
                            _vm._v("首选"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tag-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mainMovieInfo.primary &&
                                  _vm.mainMovieInfo.primary.value
                                  ? _vm.mainMovieInfo.primary.value + "%"
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "(均值" +
                                _vm._s(
                                  _vm.mainMovieInfo.primary
                                    ? _vm.mainMovieInfo.primary.average + "%"
                                    : "--"
                                ) +
                                ")"
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "right-rating-index as-flex flex-vertical main-start cross-center",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "as-flex flex-vertical main-start cross-center f-2",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-title as-full-width as-flex main-start cross-end f-2",
                        },
                        [
                          _c("span", [_vm._v("口碑指标")]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "口碑指标包括喜爱度、推荐度、与其达成，适用于映后的市场分析",
                                placement: "top",
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "question-tip-icon icon-2",
                                attrs: {
                                  tabindex: "0",
                                  src: require("../../assets/images/question@3x.png"),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "f-1 fc-gray-2" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.offsetMapping[_vm.mainMovieInfo.offset]
                                ) +
                                ")"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-line as-full-width as-flex main-between cross-end f-1 fc-gray-2",
                        },
                        [
                          _c("span", { staticClass: "tag-title" }, [
                            _vm._v("喜爱  "),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tag-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mainMovieInfo.rating &&
                                  _vm.mainMovieInfo.rating.value
                                  ? _vm.mainMovieInfo.rating.value + "%"
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "(均值" +
                                _vm._s(
                                  _vm.mainMovieInfo.rating
                                    ? _vm.mainMovieInfo.rating.average + "%"
                                    : "--"
                                ) +
                                ")"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-line as-full-width as-flex main-between cross-end f-1 fc-gray-2",
                        },
                        [
                          _c("span", { staticClass: "tag-title" }, [
                            _vm._v("推荐  "),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tag-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mainMovieInfo.recommendation &&
                                  _vm.mainMovieInfo.recommendation.value
                                  ? _vm.mainMovieInfo.recommendation.value + "%"
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "(均值" +
                                _vm._s(
                                  _vm.mainMovieInfo.recommendation
                                    ? _vm.mainMovieInfo.recommendation.average +
                                        "%"
                                    : "--"
                                ) +
                                ")"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "half-line as-full-width as-flex main-between cross-end f-1 fc-gray-2",
                        },
                        [
                          _c("span", { staticClass: "tag-title" }, [
                            _vm._v("预期达成"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "tag-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mainMovieInfo.expectation &&
                                  _vm.mainMovieInfo.expectation.value
                                  ? _vm.mainMovieInfo.expectation.value + "%"
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "(均值" +
                                _vm._s(
                                  _vm.mainMovieInfo.expectation
                                    ? _vm.mainMovieInfo.expectation.average +
                                        "%"
                                    : "--"
                                ) +
                                ")"
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }